// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-tablet-portrait-up":"576","buttonGroup":"Bestellzusammenfassung_buttonGroup__1-uNa","mobile":"Bestellzusammenfassung_mobile__gRn_U"};